// extracted by mini-css-extract-plugin
export default {"scoresPageContainer":"ScoresManagementPage_scoresPageContainer__BwYsI","buttonWrapper":"ScoresManagementPage_buttonWrapper__vVt6y"};